import { ON_CHANGE_DEBOUNCE_TIMER } from '@/scripts/core/global'
import { fetchConfig } from '@/scripts/core/global';
import { TsDOM as q, debounce } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl';

export class CartNote extends UcoastEl {
	static htmlSelector = 'cart-note'
	input: HTMLTextAreaElement
	fieldCount: HTMLElement
	propertyInput: HTMLFormElement
	constructor() {
		super()
		this.input = q.rs('textarea', this)
		this.fieldCount = q.rs('.cart__note-field-count', this)
		this.propertyInput = q.rs('input[name="note"]', this)

		this.input.addEventListener(
			'change',
			debounce((event: Event) => {
				const target = q.rt<Event, HTMLTextAreaElement>(event)
				const body = JSON.stringify({ note: target.value })
				void fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
			}, ON_CHANGE_DEBOUNCE_TIMER)
		)

		this.input.addEventListener('keyup', this.onChangeInput.bind(this))
	}

	onChangeInput(e: Event) {
		const noteSize = this.input.value.length
		this.fieldCount.textContent = `${noteSize} / 280`
		this.propertyInput.value = this.input.value
		this.propertyInput.disabled = this.input.value.length == 0
	}
}
